import { useLocalStorageState } from '@/app/components/useLocalStorageState';
import { splitFilterWords } from '@/shared/parse';
import React from 'react';

export const useFilterText = (name: string): [string, (s: string) => void, string[]] => {
  const [filterText, setFilterText] = useLocalStorageState<string>(name, '');
  const [filterWords, setFilterWords] = React.useState<string[]>([]);
  React.useEffect(() => {
    const timeout = setTimeout(() => setFilterWords(splitFilterWords(filterText)), 500);
    return () => clearTimeout(timeout);
  }, [filterText]);

  return [filterText, setFilterText, filterWords];
}